




















































import Vue from 'vue'
import { signoutConfirm } from '@/utility/helpers'
import TwoFactorCodeInput from './TwoFactorCodeInput.vue'
export default Vue.extend({
    name: 'VerificationForm',
    components: { TwoFactorCodeInput },
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        imgCenter: {
            type: String,
            required: false
        },
        imgQuote: {
            type: String,
            required: false
        },
        imgTitle: {
            type: String,
            required: false
        },
        methodOfVerification: {
            type: String,
            required: true
        },
        error: {
            type: String,
            required: false
        },
        quoteLine1: {
            type: String,
            required: false
        },
        quoteLine2: {
            type: String,
            required: false
        },
        titleText: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        TwoFactor: {
            type: Boolean,
            default: false,
            required: false,
        }
    },
    data() {
        return {
            verificationCode: null,
            verifyObject: {
                code: null,
                type: ''
            }
        }
    },
    methods: {
        clearCode(): void {
            this.$refs.codeInput?.resetValues()
        },
        onChange(val): void {
            this.verificationCode = val
        },
        handleSignOut(): void {
            signoutConfirm()
        },
        handleSubmit(): void {
            // Clear Code from UI
            this.clearCode()

            // If not dialog, emit code to parent component
            if (!this.dialog) return this.$emit('submit', this.verificationCode)

            // This is used when the dialog component is the parent component
            // Else, add code to the verifyObject
            this.verifyObject.code = this.verificationCode

            // add type to verifyObject
            this.verifyObject.type = 'verify'

            // Emit this object to parent component
            this.$emit('submit', this.verifyObject)
        },
        handleResend(): void {
            // Clear the code from UI
            this.clearCode()

            //If not dialog, emit resend to parent component
            if (!this.dialog) return this.$emit('resend')

            // This is used when the dialog component is the parent component
            // Else, change verifyObject type to resend
            this.verifyObject.type = 'resend'

            //Emit this object to the parent
            this.$emit('submit', this.verifyObject)
        }
    }
})
